export default __webpack_public_path__ + "static/media/2502104.cd0844f0.png";